import React, { useState } from "react";
import { Accordion, AccordionDetails, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import { CustomAccordionSummary } from "../../citizen/AVPForms/components/StyledComponent";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import axios from "axios";
import FileUploader from "../../citizen/AVPForms/reusableComponents/FileUploader2";
import { useSelector } from "react-redux";
function DeactivateEmployee({ t, control, handleSubmit, onSubmit, watch, departmentList, getOfficesListForIndex, getOtherRoleName, trigger }) {
  const [loading, setLoading] = useState(true);
  const [showError, setShowError] = useState(false);
  const [employeeIdList, setEmployeeIdList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const user = Digit.UserService.getUser();
  const { documents } = useSelector((state) => state.formMT);
  const userInfo = user.info || {};
  const authToken = user?.access_token || null;
  const stateId = Digit.ULBService.getStateId();
  const columns = [
    { id: "empId", label: "Employee Id", width: "17%" },
    { id: "name", label: "Name", width: "16%" },
    { id: "role", label: "Role", width: "13%" },
    { id: "remark", label: "Remark", width: "13%" },
    { id: "upload", label: "Upload", width: "13%" },
  ];
  const watchFromEmp = watch("employeeIdDeactivate");
  async function handleEmpSearch(authority) {
    if (!authority) {
      return;
    }
    const watchDepartment = watch("selectedDepartment");
    setLoading(true);
    const location = watchDepartment === "DA" ? authority?.split(" ")[0] : authority?.split(",")[1]?.trim();
    console.log("locationFromHandleEMpSearch", location);
    const payload = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken,
        userInfo: user?.info,
      },
    };
    try {
      const response = await axios.post(`${Urls.hrms.employeeSearch}?location1=${location}`, payload);
      setEmployeeList(response?.data?.user);
      setEmployeeIdList(
        (response?.data?.user || []).map((employee) => ({
          label: String(`${employee?.userName} - ${employee?.name}`),
          value: String(`${employee?.userName} - ${employee?.name}`),
          name: String(`${employee?.userName} - ${employee?.name}`),
          payload: employee,
        }))
      );
      setLoading(false);
      return response.data;
      // console.log("responseFromEmpSearch", response?.data);
    } catch (error) {
      console.error("Error fetching employees", error);
      setLoading(false);
      throw error;
    }
  }
  const validateFiles = () => {
    const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
    const requiredDocs = ["deactivateOrder"];

    return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  };
  const handleDeactivateEmp = async (uuid) => {
    trigger();
    const isValid = validateFiles();
    if (isValid) {
      console.log("submitIf", isValid, data);
      handleTabChange(1, data);
      // onSubmit(data);
    } else {
      setShowError(true);
      console.log("submitElse", isValid, showError);
      return;
    }
    if (!uuid) return;
    console.log("uuidfromfunc", uuid);
    let result = 0;
    try {
      result = await Digit.WorkflowService.getCount("up", { assignee: uuid });
      console.log("loggingcountresponse", result);
    } catch (error) {
      console.error("Error while fetching count:", error);
    }
    if (result.data !== 0) {
      alert("Employee cannot be deactivated as there are pending files assigned.");
      return;
    }
    const selectedUser = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
    console.log("selectedUser", selectedUser);

    try {
      const payload = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken: authToken,
          userInfo: userInfo,
          msgId: "1743578637716|en_IN",
        },

        userName: selectedUser?.user?.[0]?.userName,
      };
      const response = await axios.post(`${Urls.hrms.deactivateUser}`, payload);
      alert("Employee Deactivated Successfully");
      console.log("logafterdeactivation", response);
    } catch (error) {
      console.error("Error while deactivating employee:", error);
      alert("Failed to deactivate employee. Please try again.");
      return;
    }
  };
  return (
    <section className="groupContainer2">
      <form className="formContainer" onSubmit={handleSubmit(onSubmit)}>
        <Accordion>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Deactivate Employee")}</h2>
            </div>
          </CustomAccordionSummary>

          <AccordionDetails className="formInputContainer common-app-form">
            {/* FROM Section */}

            <Container fluid>
              <Row className="mb-3">
                <Col>
                  <InputWrapper
                    control={control}
                    label="Department"
                    name={`selectedDepartment`}
                    type="selectInput"
                    data={departmentList}
                    mandatory
                    validation={{
                      required: { value: true, message: "This field is required" },
                    }}
                  />
                </Col>

                <Col>
                  <InputWrapper
                    control={control}
                    label="Authority"
                    name={`selectedAuthorityDeactivate`}
                    type="selectInput"
                    data={getOfficesListForIndex(watch("selectedDepartment"))}
                    mandatory
                    validation={{
                      required: { value: true, message: "This field is required" },
                    }}
                    // disabled={!getApplicationFlowForIndex()}
                  />
                </Col>
              </Row>

              {employeeIdList?.length > 0 && (
                <Row className="mb-3">
                  <Col>
                    <InputWrapper
                      control={control}
                      label={"Select Employee Id"}
                      inputLabel="Select Employee Id"
                      placeholder="Select Employee Id"
                      name="employeeIdDeactivate"
                      type="searchSelect"
                      returnObject={true}
                      data={employeeIdList}
                      mandatory
                      validation={{
                        required: { value: true, message: "This field is required" },
                      }}
                    />
                  </Col>
                  <Col></Col>
                </Row>
              )}
            </Container>
            {watchFromEmp &&
              (() => {
                const selectedEmpRole = getOtherRoleName(watchFromEmp?.payload?.roles || []);
                console.log("selectedEmpROle", selectedEmpRole);
                return (
                  <TableContainer component={Paper} className="table-container emp-transfer-tablecontainer">
                    {" "}
                    <Table stickyHeader aria-label="noc info table" className="application-table">
                      {" "}
                      <TableHead>
                        {" "}
                        <TableRow className="citizen-header-row">
                          {" "}
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              style={{ width: column.width, fontWeight: "bold", background: "#1f4a7c", color: "#fff", fontSize: "13px" }}
                            >
                              {" "}
                              {column.label}{" "}
                            </TableCell>
                          ))}{" "}
                        </TableRow>{" "}
                      </TableHead>{" "}
                      <TableBody>
                        {" "}
                        <TableRow>
                          {" "}
                          <TableCell style={{ fontSize: "13px" }}>{watchFromEmp.payload.userName || "-"}</TableCell>{" "}
                          <TableCell style={{ fontSize: "13px" }}>{watchFromEmp.payload.name || "-"}</TableCell>{" "}
                          <TableCell style={{ fontSize: "13px", textAlign: "center" }}>{selectedEmpRole || "-"}</TableCell>{" "}
                          <TableCell style={{ fontSize: "13px", textAlign: "center" }}>
                            {
                              <InputWrapper
                                width={"100%"}
                                hasLabel={false}
                                control={control}
                                placeholder="Enter remarks"
                                name={`deactivateRemarks`}
                                type={"textInput"}
                                mandatory
                                isRequired
                                validation={{
                                  required: { value: true, message: "This field is required" },
                                }}
                              />
                            }
                          </TableCell>{" "}
                          <TableCell style={{ fontSize: "13px", textAlign: "center" }}>
                            {
                              <FileUploader
                                isMandatory
                                hasLabel={false}
                                // label="Complete drawing including location/site plan, key plan"
                                control={control}
                                name="deactivateOrder"
                                validationMsg="Upload File"
                                required
                                tab={4}
                                showError={showError}
                                maxFiles={1}
                              />
                            }
                          </TableCell>{" "}
                        </TableRow>{" "}
                      </TableBody>{" "}
                    </Table>{" "}
                  </TableContainer>
                );
              })()}

            {/* Buttons */}
            <div className="buttonWrapper emp-transfer-buttonwrapper">
              <ButtonWrapper
                variant="contained"
                color="info"
                size="medium"
                label={
                  <React.Fragment>
                    Search{" "}
                    <SearchIcon
                      sx={{
                        color: "#fff",
                        height: "18px",
                        width: "18px",
                      }}
                    />
                  </React.Fragment>
                }
                type="button"
                disabled={!watch("selectedAuthorityDeactivate")}
                onClick={() => handleEmpSearch(watch("selectedAuthorityDeactivate"))}
                sx={{ backgroundColor: "#1565C0", marginRight: "4px", marginTop: "20px" }}
              />
              <ButtonWrapper
                variant="contained"
                color="warning"
                size="medium"
                label={"Deactivate"}
                type="button"
                disabled={!watch("employeeIdDeactivate")}
                onClick={() => handleDeactivateEmp(watchFromEmp?.payload?.uuid)}
                sx={{ backgroundColor: "#ED6C02", marginRight: "4px", marginTop: "20px" }}
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </form>
    </section>
  );
}

export default DeactivateEmployee;
